import {isIE} from '../../../utility/js/tests';
import {fixedHeaderHeight} from '../../../utility/js/utils';
import Stickyfill from '../../polyfills/js/stickyfill.es';
import '../../polyfills/js/NodeList/forEach';
import '../../polyfills/js/Element/matches';
import '../../polyfills/js/Element/closest';

(function (UX) {
    /**
     ****************************
     ***** Sticky Elements ******
     ****************************
     *
     * Sticky Elements object is responsible for stickiness in all UX3 sites, it uses CSS3 `position: sticky;`
     * instead of `fixed`, for IE it uses `stickybits` plugin as a polyfill. Covering all sticky cases
     * in UX3 with minimum code. Also. Hooks can be used for extending its functionality. It used
     * to replace old stickiness solutions:(1) Header with position fixed. (2) CoolBar with
     * stickybar.js. (3) sticko.js plugin (4) Scroll them fix header-scroll-fix.js
     *
     */
    UX.stickyElements = {
        /**
         * Different Selectors
         */
        selectors: {
            header: '.header',
            scrollThenFix: '.scrollThenFix',
            stickyElements: ['.fixed-element'],
            // Elements can be in header cause its height to be dynamic
            dynamicHeader: ['.pb-ad', '.pb-las', '.cookiePolicy-popup', '.header__dropzone'],
            stickoParent: '.sticko__parent',
        },

        /**
         * Holds header object
         * @type {HTMLElement}
         */
        header: null,

        /**
         * Toggle header stickiness
         * @type {boolean}
         */
        isHeaderSticky: true,

        /**
         * Use dynamic header height computed by JS instead of CSS fixed value
         * @type {boolean}
         */
        dynamicHeaderHeight: false,

        // For responsive
        vPort: 'screen-sm',
        isMobile: false,

        init() {
            this.header = document.querySelector(this.selectors['header']);

            if (this.isHeaderSticky) this.selectors['stickyElements'].unshift(this.selectors['header']);

            this._isDynamicHeaderHeight();

            this.start();
            this.responsive();
            this.extra();
        },

        responsive() {
            // TODO: get rid of jQuery
            $(document).on('smartResize', () => this.start());
            $(document).on(`${this.vPort}-on`, () => (this.isMobile = true));
            $(document).on(`${this.vPort}-off`, () => (this.isMobile = false));
        },

        extra() {},

        start() {
            this.computeHeaderHeight();
            if (this.selectors['stickyElements'].length) {
                /** @type {NodeListOf<HTMLElement>} */
                const matched = document.querySelectorAll(this.selectors['stickyElements'].join(','));
                if (!matched || !matched.length) return;

                matched.forEach(item => {
                    const isHeader = item.matches(this.selectors['header']);
                    this.makeSticky(item, isHeader);
                });
            }
        },

        /**
         * Make sure stickyElements are stick correctly
         * @param {HTMLElement} item
         * @param {boolean} isHeader
         */
        makeSticky(item, isHeader) {
            this.setTopValue(item, isHeader);
            this.postStickyActions(item, isHeader);
            // if IE use polyfill
            if (isIE) {
                Stickyfill.addOne(item);
            }
        },

        setTopValue(item, isHeader) {
            if (this._canSetTopValue(item, isHeader)) {
                item.style.top = this.headerHeight + 'px';
            }
        },

        /**
         * This is a magical method to run specific actions after making items sticky based on what is the item.
         * actions are saved in groups in this._actions object and they called dynamically.
         * @param {HTMLElement} item
         * @param {boolean} isHeader
         * @protected
         */
        postStickyActions: function (item, isHeader) {
            if (this._has(item, this.selectors['stickoParent'], true)) {
                this.stickoActions(item);
            }
            if (this._has(item, this.selectors['scrollThenFix'])) {
                this.scrollThenFixActions(item, isHeader);
            }
        },

        /**
         * Set sticko height to fill the viewport excluding the fixed header
         * @param {HTMLElement} item
         * @protected
         */
        stickoActions(item) {
            const stickoParent = item.querySelector(this.selectors['stickoParent']) || item;
            if (this.isHeaderSticky) stickoParent.style.height = `calc(100vh - ${this.headerHeight}px)`;
            else stickoParent.style.height = '100vh';
            document.addEventListener('change:auto-hide-bar', () => {
                item.style.top = `${fixedHeaderHeight()}px`;
            });
        },

        /**
         * Make it sticky as soon as reach the fixed element inside it
         * @param {HTMLElement} item
         * @param {boolean} isHeader
         */
        scrollThenFixActions(item, isHeader) {
            item.classList.add('fixed-element');
            let scrollThenFixOffset = item.querySelector(this.selectors['scrollThenFix']).offsetTop;
            scrollThenFixOffset -= !isHeader ? this.headerHeight : 0;
            item.style.top = `${-1 * scrollThenFixOffset}px`;
        },

        /**
         * Check if to use dynamic header height
         * @return {void}
         * @private
         */
        _isDynamicHeaderHeight() {
            if (!this.dynamicHeaderHeight) {
                for (let i = 0; i < this.selectors['dynamicHeader'].length; i++) {
                    this.dynamicHeaderHeight = this._has(this.header, this.selectors['dynamicHeader'][i], true);
                    if (this.dynamicHeaderHeight) break;
                }
            }
        },

        computeHeaderHeight() {
            this.headerHeight = fixedHeaderHeight(this.selectors['header']);
        },

        /**
         *
         * @param {HTMLElement} item
         * @param {string} selector
         * @param {boolean} [self]
         * @return {*|boolean}
         * @private
         */
        _has(item, selector, self) {
            return (
                item &&
                (item.querySelector(selector) !== null || // if item contains element matches the selector
                    (self && item.matches(selector))) // or item itself matches the selector
            );
        },

        _canSetTopValue(item, isHeader) {
            return !isHeader && this.dynamicHeaderHeight && item.closest(this.selectors['header']) === null;
        },
    };
})(UX);
